import { render } from "./CustomSelect.vue?vue&type=template&id=1f179cd0&scoped=true&ts=true"
import script from "./CustomSelect.vue?vue&type=script&lang=ts"
export * from "./CustomSelect.vue?vue&type=script&lang=ts"

import "./CustomSelect.vue?vue&type=style&index=0&id=1f179cd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f179cd0"]])

export default __exports__